<template>
  <div class="address-wrap">
      <div class="address-wrap_h3">
          <span>收货地址</span>
          <div class="address-wrap_h3_add" @click="$to_link('/centerAddAddress')">
              <img src="../../assets/img/add_address.png" alt="">
              <span class="u-m-l-8">创建收货地址</span>
          </div>
      </div>
      <div class="address-wrap_list">
          <div class="address-wrap_item" v-for="(item,index) in list" :key="index">
              <div class="address-wrap_item_p">
                  <p>收货人：    {{item.name}}</p>
                  <p>所在地区：{{item.areaName}}</p>
                  <p>详细地址：{{item.address}} </p>
                  <p>手机号码：{{item.phone}}</p>
              </div>
              <div class="address-wrap_item_bottom">
                  <div class="address-wrap_item_bottom_btn" v-if="item.if_default == 1">
                      <span>默认</span>
                  </div>
                  <div class="u-flex address-wrap_btns">
                        <span class="address-wrap_btns-item" @click="$to_link('/centerAddAddress',{id:item.id})">编辑</span>
                        <el-popconfirm title="确定删除吗？" @confirm="delConfirmFun(item,index)">
                            <span class="address-wrap_btns-item" slot="reference">删除</span>
                        </el-popconfirm>
                      
                  </div>
              </div>
          </div>
      </div>
  </div>
</template>

<script>
export default {
    data(){
        return {
            params:{
                page:1,
                pagenum:100
            },
            list:[]
        }
    },
    created(){
        this.getListFun()
    },
    methods:{
        //获取地址列表
        async getListFun(){
            let res = await this.$http.get('userAddress_lists', this.params)
            if(res.code == 1){
                this.list = res.data
            }
        },
        //删除购物车
        async delConfirmFun(item,index){
            let res = await this.$http.get('userAddress_delete',{id:item.id})
            if(res.code == 1){
                this.$message.success(res.message)
                this.list.splice(index,1)
            }else{
                this.$message.error(res.message)
            }
        }
    }
}
</script>
<style lang="scss">
.address-wrap{
    .address-wrap_h3{
        display: flex;
        align-items: center;
        justify-content: space-between;
        span{
             font-size: 16px;
              font-family: Microsoft YaHei;
              font-weight: bold;
              line-height: 20px;
              color: #333333;
        }
        .address-wrap_h3_add{
            display: flex;
            align-items: center;
            cursor: pointer;
            user-select: none;
            &:active{
                opacity: 0.6;
            }
            span{
                font-size: 14px;
                font-family: Microsoft YaHei;
                font-weight: 400;
                line-height: 20px;
                color: #FF3D00;
            }
            img{
                width: 18px;
                height: 18px;
            }
        }
    }

    .address-wrap_list{
        padding-top: 20px;
        .address-wrap_item{
            border: 1px solid #ccc;
            width: 100%;
            padding: 20px 20px 0 20px;
            margin-bottom: 20px;
            .address-wrap_item_p{
              padding-bottom: 20px;
              border-bottom: 1px solid #eee;
              p{
                  font-size: 14px;
                  font-family: Microsoft YaHei;
                  font-weight: 400;
                  line-height: 24px;
                  color: #7D7D7D;
              }
            }
            .address-wrap_item_bottom{
                display: flex;
                justify-content: space-between;
                align-items: center;
                height: 60px;
                .address-wrap_item_bottom_btn{
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    width: 40px;
                    height: 18px;
                    background: #F29F25;
                    span{
                        color: #fff;
                        font-size: 12px;
                    }
                }
                .address-wrap_btns{
                    .address-wrap_btns-item{
                        font-size: 14px;
                        font-family: Microsoft YaHei;
                        font-weight: 400;
                        line-height: 20px;
                        color: #333333;
                        cursor: pointer;
                        user-select: none;
                        margin-left: 20px;
                        &:active{
                            opacity: 0.6;
                        }
                    }
                }
            }
        }
    }
}
</style>
